export default class Buttons {
    static init() {
        this.buttons = document.querySelectorAll(".btn, .btn-fill, .btn-stroke, .btn-light");

        this.buttons.forEach((button) => {

            const text = `<span class='label'>${button.innerHTML}</span>`;
            button.innerHTML = text;

            if (button.classList.contains('btn-go') || button.classList.contains('btn-back')) {
                const element = document.createElement("span");
                element.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
				  <path d="M4.29726 1.70274L7.50189 4.90611H0L0 7.09389H7.50189L4.29726 10.2973L6 12L12 6L6 0L4.29726 1.70274Z" fill="currentColor"/>
				</svg>`;
                element.classList.add('svg');
                button.appendChild(element);
            }

            if (button.classList.contains('btn-download')) {
                const element = document.createElement("span");
                element.innerHTML = `<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.51223 5.64288L0.5 6.63552L7.5 13.5L14.5 6.63552L13.488 5.64288L8.21598 10.8129L8.21598 0.5L6.78441 0.5L6.78441 10.8129L1.51223 5.64288Z"/>
<path d="M2 15H13V16H2V15Z"/>
</svg>`;
                element.classList.add('svg');
                button.appendChild(element);
            }

            if (button.classList.contains('btn-gallery')) {
                const element = document.createElement("span");
                element.innerHTML = `<svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 1H16V10M1 4H13V13H1V4Z" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
                element.classList.add('svg');
                button.appendChild(element);
            }
            if (button.classList.contains('btn-lock')) {
                const element = document.createElement("span");
                element.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.932039 6.23529H1.1068V4.41176C1.1068 2.23529 2.38835 0.882353 4.01942 0.294118C4.66019 0.117647 5.30097 0 5.94175 0C6.58252 0 7.28155 0.117647 7.86408 0.294118C9.5534 0.941176 10.8932 2.29412 10.8932 4.41176V6.23529H11.068C11.5922 6.23529 12 6.64706 12 7.17647V15.0588C12 15.5882 11.5922 16 11.068 16H0.932039C0.407767 16 0 15.5882 0 15.0588V7.17647C0 6.64706 0.407767 6.23529 0.932039 6.23529ZM3.20388 6.23529H8.79612V4.41176C8.79612 3.35294 8.09709 2.58824 7.16505 2.29412C6.81553 2.17647 6.34951 2.05882 5.94175 2.05882C5.53398 2.05882 5.12621 2.17647 4.71845 2.29412C3.84466 2.58824 3.20388 3.29412 3.20388 4.41176V6.23529ZM6 9.70588C6.81553 9.70588 7.45631 10.4118 7.45631 11.2353C7.45631 12.0588 6.81553 12.7059 6 12.7059C5.18447 12.7059 4.48544 12.0588 4.48544 11.2353C4.48544 10.4118 5.18447 9.70588 6 9.70588Z" fill="#312783"/>
</svg>`;
                element.classList.add('svg');
                button.appendChild(element);
            }

            if (button.classList.contains('btn-lang')) {
                const element = document.createElement("span");
                element.innerHTML = `<svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.08786 0.982932L8.15892 8.054L7.07107 9.14186L0 2.07079L1.08786 0.982932Z" fill="#34847A"/>
<path d="M14.1422 2.07077L7.07107 9.14186L5.98332 8.05398L13.0544 0.98291L14.1422 2.07077Z" fill="#34847A"/>
</svg>`;
                element.classList.add('svg');
                button.appendChild(element);
            }

        });

    }

}
